import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';

import { finalize, tap } from 'rxjs/operators';
import { AnalyticsService } from '../../core/analytics-service/analytics.service';
import { Result } from '../../core/yesno-service/result';
import { YesnoService } from '../../core/yesno-service/yesno.service';
import { isbnValidator } from '../../shared/isbn.directive';

@Component({
  selector: 'app-yesno',
  templateUrl: './yesno.component.html',
  styleUrls: ['./yesno.component.scss'],
})
export class YesnoComponent implements OnInit, AfterViewInit, OnDestroy {
  public hasResult = false;
  public shouldSend!: Result;
  public error = '';
  public isLoading = false;
  public isbnForm: UntypedFormGroup = this.fb.group({
    isbn: [''],
  });
  public isbnFormControl: UntypedFormControl = new UntypedFormControl();
  @ViewChild('input', { static: true })
  el!: ElementRef;
  public result = Result;
  private subscription = new Subscription();

  constructor(
    private fb: UntypedFormBuilder,
    private service: YesnoService,
    private analyticsService: AnalyticsService,
  ) {
    this.createForm();
  }

  get isbn(): AbstractControl | null {
    return this.isbnForm.get('isbn');
  }

  ngOnInit(): void {
    this.subscription.add(
      this.isbn?.valueChanges.subscribe(() => {
        this.hasResult = false;
      }),
    );
  }

  ngAfterViewInit(): void {
    this.setFocusOnIsbn();
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSubmit(): void {
    if (this.isbnForm.valid) {
      const id = this.isbn?.value.replace(/-/g, '').trim();
      this.error = '';
      this.isLoading = true;
      this.service
        .doWeWantThis(id)
        .pipe(
          tap((result: Result) =>
            this.analyticsService.trackEvent({
              action: 'search',
              properties: {
                event_category: 'Holdings',
                event_label: id,
                svar: this.createLabel(result),
              },
            }),
          ),
          finalize(() => {
            this.isLoading = false;
            this.selectIsbn();
          }),
        )
        .subscribe(
          (result: Result) => {
            this.hasResult = true;
            this.shouldSend = result;
          },
          () => {
            this.hasResult = false;
            this.error = 'Ooopsiee... Noe gikk galt...';
          },
        );
    }
  }

  createLabel(result: Result): string {
    switch (result) {
      case Result.Yes:
        return 'Ja, takk!';
      case Result.No:
        return 'Nei, takk!';
    }
  }

  private createForm(): void {
    this.isbnFormControl = new UntypedFormControl('', [
      Validators.required,
      isbnValidator(),
    ]);
    this.isbnForm = this.fb.group({
      isbn: this.isbnFormControl,
    });
  }

  private setFocusOnIsbn(): void {
    try {
      setTimeout(() => this.el.nativeElement.focus());
    } catch (e) {
      // continue regardless of error
    }
  }

  private selectIsbn(): void {
    try {
      this.el.nativeElement.select();
    } catch (e) {
      // continue regardless of error
    }
  }
}
